"use strict";

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var Backbone = require('dibs-backbone');

// ---------------------------------------------------
// Module Definition

/**
 * @class FieldRule
 *
 * Base pseudoclass for validated field rules. Contains
 * an 'outputSchema' method that outputs an object used
 * by the {@link Validator} class. You extend this
 * class and define a 'validate' method (returning a
 * boolean) to tell the Validator class if the
 * field violates this Rule or not.
 * @param {object} [options]
 * @param {boolean} [options.noMatch] Overrides property of the same name
 * @param {string} [options.message] Overrides property of the same name
 * @param {string} [options.messageBody="is invalid"] Overrides property of the same name
 *
 * @property {string} message
 *      A message for to display if {@link Validator}
 *      determines a field's value to be false for this
 *      rule
 * @property {boolean} noMatch
 *      If the inverse of this rule's result should be
 *      used to determine if a validation error occurred or
 *      not. For example: if the rule's validate method
 *      returns 'true', which would normally pass validation,
 *      it would be considered an error if noMatch is true.
 * @property {string} messageBody
 *      If defined and the parent {@link FieldValidation}
 *      has a fieldDisplayName defined, than they will be combined
 *      to create a 'message'. This is a assuming a message is
 *      not defined. If a custom message option is provided, then
 *      messageBody will be ignored
 * @property {string} defaultMessage
 *      If no 'message' exists and one cannot be constructed
 *      from the 'messageBody', then the 'defaultMessage'
 *      wold be used for this field.
 *
 */
var FieldRule = module.exports = function () {
    this.initialize.apply(this, arguments);
};

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(FieldRule.prototype, {

    messageBody: "is invalid",

    initialize: function (options) {
        options = options || {};
        this.validate = options.validate || this.validate;
        this.noMatch = _.isBoolean(options.noMatch) ? options.noMatch : this.noMatch;
        this.setMessage(!_.isUndefined(options.message) ? options.message : this.message);
        this.setMessageBody(!_.isUndefined(options.messageBody) ? options.messageBody : this.messageBody);
    },

    /**
     * Set the error message for this rule
     * should the validation not pass
     * @param message
     * @returns {FieldRule}
     */
    setMessage: function (message) {
        this.message = message;
        return this;
    },

    /**
     * @param messageBody
     * @returns {FieldRule}
     */
    setMessageBody: function (messageBody) {
        this.messageBody = messageBody;
        this.defaultMessage = 'This field ' + messageBody;
        return this;
    },

    /**
     * @param {FieldValidation} parentValidation
     * @returns {FieldRule}
     */
    setParentValidation: function (parentValidation) {
        this._parentValidation = parentValidation;
        return this;
    },

    /**
     * @returns {FieldValidation}
     */
    getParentValidation: function () {
        return this._parentValidation;
    },

    ///**
    // * Default message function
    // * @returns {string}
    // */
    //message: function () {
    //    var messageBody = _.result(this, 'messageBody');
    //    var parentValidation = this.getParentValidation();
    //    if (parentValidation && parentValidation.fieldDisplayName && messageBody) {
    //        return FieldRule.createMessageWithBody(parentValidation.fieldDisplayName, messageBody);
    //    }
    //    return _.result(this, 'defaultMessage') || 'This field is invalid';
    //},

    /**
     * Override in extension. Gets invoked by {@link Validator}
     * @param {Backbone.Model} model
     * @param {*} value
     * @param {string} fieldName
     * @returns {boolean}
     */
    validate: function (model, value, fieldName, required) {}, //eslint-disable-line

    /**
     * Output the {@link Validator} config json
     * for this rule
     * @returns {object}
     */
    outputSchema: function () {
        var self = this;
        return {
            noMatch: self.noMatch,
            message: self.message,
            validator: function (value, fieldName, required) {
                if (required !== !!required) { // if required isn't a bool (undefined, null, whatever) then default to true
                    required = true;
                }
                return self.validate(this, value, fieldName, required); // "this" is the model in this context
            }
        };
    }
}, Backbone.Events);

// ---------------------------------------------------
// Define Module Static Properties

_.extend(FieldRule, {
    /**
     * @function
     * @param {object} instanceProperties
     * @param {object} staticProperties
     * @returns {function} New constructor function
     */
    extend: Backbone.Model.extend, // Give this pseudoclass the ability to be extended,

    /**
     * @param {string} fieldDisplayName
     * @param {string} messageBody
     * @returns {string}
     */
    createMessageWithBody: function (fieldDisplayName, messageBody) {
        return '"' + fieldDisplayName + '" field ' + messageBody;
    }

});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/validation/deprecated/rules/FieldRule.js
// module id = 46
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56